import { InjectionToken, LockManager, PulseStorage, StorageSelector } from '@pulse/common';
import { PulseWindow } from '../globals';
import { PulseBroadcastChannel } from '../services';

export const WindowToken = new InjectionToken<PulseWindow, 'Window'>('Window');

export const StorageSelectorToken = new InjectionToken<StorageSelector, 'STORAGE_SELECTOR'>(
    'STORAGE_SELECTOR',
);

export const CookieBroadcastChannelToken = new InjectionToken<PulseBroadcastChannel, 'COOKIE_BC'>(
    'COOKIE_BC',
);

export const UnPrefixedCookieStorageToken = new InjectionToken<
    PulseStorage,
    'UN_PREFIXED_COOKIE_STORAGE'
>('UN_PREFIXED_COOKIE_STORAGE');

export const LockManagerToken = new InjectionToken<LockManager, 'LOCK_MANAGER'>('LOCK_MANAGER');

export const PrefixedCookieStorageToken = new InjectionToken<
    PulseStorage,
    'PREFIXED_COOKIE_STORAGE'
>('PREFIXED_COOKIE_STORAGE');
